import { isKeyHotkey } from 'is-hotkey';
import isInEmbedPlaceholder from '../utils/isInEmbedPlaceholder';
var isEnter = isKeyHotkey('enter');
export default function makeOnKeyDown(store) {
  /**
   * User is pressing a key in the editor
   */
  return function onKeyDown(event, editor, next) {
    var value = editor.value;
    var inEmbedPlaceholder = isInEmbedPlaceholder(value); // Inside embed placeholder ?

    if (!inEmbedPlaceholder) {
      return next();
    }

    if (isEnter(event)) {
      var currentNode = editor.value.anchorBlock;

      var _store$getItem = store.getItem(currentNode.key),
          onSubmit = _store$getItem.onSubmit;

      return onSubmit();
    }

    return next();
  };
}